import { useTaskSlice } from 'app/containers/Task/slice';
import { ITask } from 'app/containers/Task/slice/types';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useTaskRecipeDescriptionAsNote = ({ task }: { task?: ITask }) => {
  const dispatch = useDispatch();
  const taskActions = useTaskSlice().actions;

  // Set recipe description as task note on recipe select
  const [
    taskRecipeDescriptionAsNote,
    setTaskRecipeDescriptionAsNote,
  ] = useState<string | null>(null);

  // Set recipe description as note
  useEffect(() => {
    if (task?.recipe) {
      dispatch(taskActions.setTaskRecipe(task.recipe));
    }

    return () => {
      // Reset recipe value on unmount
      dispatch(taskActions.setTaskRecipe(null));
    };
  }, [task, dispatch, taskActions]);

  return { taskRecipeDescriptionAsNote, setTaskRecipeDescriptionAsNote };
};
